// 계약 사실화 1단계(26-07-28) 결함 ③ — 계약 줄의 '판매/구독' 표기 정본.
//
// 같은 값(ContractLine.reason / Deployment.reason = DeploymentReason)이 화면마다
// 다르게 보이던 것을 한 벌로 모은다:
//   • 로봇 목록 '구분' 칸 — 'SALE' 이면 '판매', 나머지 전부 '구독'(로컬 함수)
//   • 계약 상세 '계약 라인' 표 '이유' 칸 — 영문 enum 원문 그대로('SALE',
//     'LEASE_OPERATING') 노출. 운영자가 읽을 수 없는 값이 계약서 화면에 그대로
//     찍히던 것이 이 결함이다.
// KST 날짜 포맷터(lib/format-date)를 정본화한 것과 같은 원칙 — 표기 규칙은
// lib 에 한 벌만 두고 화면은 그것을 부른다(중복 구현 금지).
//
// 계약 사실화 1단계 정정(26-07-28) — "정본"이라 선언만 하고 실제 사용처가 계약
// 상세 한 곳뿐이었다. 남아 있던 중복 2벌을 이 파일로 들여왔다:
//   • 로봇 목록(RobotsListPage) 로컬 formatContractReason — 옛 이분 규칙
//     ("SALE 이면 판매, 나머지 전부 구독")
//   • 계약 등록 마법사(ContractCreateWizard) REASON_LABEL — 세 번째 라벨 세트
//     ('운용 리스' / '금융 리스' / '데모' / '이벤트' / '내부')
// 두 화면이 같은 값을 서로 다른 단어로 보여 주며 **서로를 반증**하고 있었다.
// 이제 값→문구 매핑은 이 파일에만 있다(짧은 표기 / 긴 표기 두 세트, 아래 참조).
//
// ⚠️ 표기 정정(판단 근거) — 종전 로봇 목록 규칙은 "SALE 외 전부 구독"이었다.
// 그러나 DeploymentReason 은 7값이고 PILOT/DEMO/EVENT/INTERNAL 은 **구독료를
// 받는 렌탈이 아니다**(파일럿·시연·행사·사내 이동). 이것을 '구독'으로 뭉개면
//   ① 계약서 화면이 "구독 계약"이라고 거짓을 말하고,
//   ② 재계약율·리텐션 모수(구독 계약 기준)에 파일럿이 섞여 지표가 오염된다.
// 그래서 렌탈 계열(LEASE_*)만 '구독'으로 부르고 나머지는 제 이름으로 적는다.
// 이 정정 당시 쌓여 있던 데이터는 고객사 화면이 SALE / LEASE_OPERATING 두 값만
// 만들던 시절의 것이라, 정정으로 기존 화면 표기가 바뀌는 건은 없었다 — 계약 등록
// 마법사로 직접 넣은 파일럿·시연 줄만 사실대로 보이게 됐다.
//
// 계약 사실화 1단계 정정4(26-07-29) 부기 — 위 "고객사 화면이 만드는 값은 2가지뿐"
// 은 **지금은 사실이 아니다**. 고객사 마스터 모달의 줄별 '계약 형태' 칸이 원문 7값을
// 그대로 보내게 됐으므로(정정 26-07-28), 파일럿·시연·행사·사내·금융리스 줄이 주
// 입력 경로에서 실제로 만들어지고 로봇 목록 '구분'·계약 상세에 그 이름으로 뜬다.
//
// 계약 사실화 1단계 정정(26-07-28) 부기 — 이 규칙이 이제 로봇 목록 '구분' 칸에도
// 적용된다. SALE='판매' / LEASE_OPERATING='구독' 은 그대로이므로 방금 확정한
// 로봇 목록 표기 약속(0단계 시험)은 그대로 통과하고, 바뀌는 것은 그 시험이
// 다루지 않던 5값(LEASE_FINANCE / PILOT / DEMO / EVENT / INTERNAL)뿐이다.
//
// 계약 사실화 1단계 정정3(26-07-28) — 위 정정이 "이제 이 파일에만 있다"고 적었지만
// 사실이 아니었다. **네 번째 세트**가 로봇 배치 모달(pages/robots/DeployRobotModal)
// '사유' 드롭다운에 그대로 남아 있었다 — 지운 마법사 세트와 글자까지 같은
// '운용 리스' / '금융 리스' / '데모' / '이벤트' / '내부'. 그래서
//   ① 아래 두 시험 파일이 같은 enum 을 두고 서로 반대를 단정했다
//      (contract-reason.test.ts: 그 단어를 쓰지 말라 / DeployRobotModal.test.tsx:
//      그 단어가 화면에 보여야 한다) — 둘 다 통과하고 있었으니 시험이 표기를
//      지켜 주지 못하는 상태였다,
//   ② 이 모달이 고르는 값이 곧 Deployment.reason 이고 그것이 인수확인서 'Reason'
//      과 로봇 목록 '구분' 으로 나가므로, 운영자가 '운용 리스'로 배치한 로봇이
//      로봇 목록에서는 '구독'으로 보였다.
// 이제 그 드롭다운도 아래 CONTRACT_REASON_OPTION_LABEL 을 부른다(계약 등록
// 마법사와 같은 자리·같은 세트). 값→문구 매핑은 여전히 이 파일 한 곳뿐이다.
//
// 정정3 전수 확인(grep) 결과 — 이 파일 밖에 남은 DeploymentReason→한국어 세트는
// 고객사 마스터 모달(pages/business/CustomerMasterCreateModal.tsx
// LINE_REASON_OPTIONS: '렌탈' 머리 단어) 한 벌이었다.
//
// 계약 사실화 1단계 정정4(26-07-29) — 정정3 이 그 **다섯 번째 세트**를 남겨 둔 근거
// ("그 화면 시험이 라벨 문구를 통째로 단정하고 있어 손대지 않았다")는 자기 순환이었다.
// 그 세트와 그것을 못 박는 시험이 **둘 다 정정3 과 같은 라운드에 새로 들어온 것**이라,
// 지켜야 할 기존 약속이 아니라 방금 만든 약속을 근거로 든 셈이다. 이번에 그 세트를
// 지우고 그 화면의 줄별 칸이 아래 CONTRACT_REASON_OPTION_LABEL 을 부르게 했다(그
// 화면 시험도 같이 고쳤다). grep 전수 확인 — 이 파일 밖에 남은 DeploymentReason→
// 한국어 세트는 **0벌**이다.
//
// ⚠ 다만 같은 모달의 **공통 '계약 형태'** 칸('렌탈' / '판매')은 성질이 다르다 — 그
// 칸의 값은 화면 표기가 아니라 **서버로 보내는 문자열 자체**(CreateCustomerMasterDto
// .contractType)다. 그래서 '렌탈'은 폐기 어휘가 아니고 아래 폐기 목록에도 넣지
// 않는다(넣으면 그 목록을 보는 시험이 살아 있는 서버 계약을 폐기로 몰아, 표기를
// 지키려던 시험이 저장을 깨뜨리는 쪽으로 뒤집힌다).

import type { DeploymentReason } from '@bhops/shared';

/** 값 없음(미배정·미입력) 표기 — 로봇 목록 '구분' 칸의 기존 관례(en-dash). */
export const CONTRACT_REASON_EMPTY = '–';

/**
 * 짧은 표기 — 표의 좁은 칸에 찍는다(로봇 목록 '구분', 계약 상세 '이유').
 *
 * 단어 선택 근거(정정 26-07-28): 오너가 쓰는 말은 '판매/구독'이다(로봇 목록·
 * 결정 문서·계획서). 계약 실무 용어인 '운용 리스/금융 리스'를 화면 단어로
 * 올리지 않고, 오너의 단어('구독')에 회계 구분을 괄호로 덧붙이는 쪽을 골랐다 —
 * 마법사에서 '운용 리스'를 고른 운영자가 로봇 목록에서 '구독'을 보고 다른
 * 계약인가 의심하지 않게 하려면 두 화면의 머리 단어가 같아야 한다.
 */
export const CONTRACT_REASON_LABEL: Record<DeploymentReason, string> = {
  SALE: '판매',
  // 운용 리스가 구독의 기본형 — 좁은 칸에서는 괄호 없이 '구독'.
  LEASE_OPERATING: '구독',
  // 금융 리스도 구독(월 과금)이지만 회계 처리가 다르므로 괄호로 구분한다.
  LEASE_FINANCE: '구독(금융리스)',
  PILOT: '파일럿',
  DEMO: '시연',
  EVENT: '행사',
  INTERNAL: '사내',
};

/**
 * 계약 사실화 1단계 정정(26-07-28) — 긴 표기. 값을 **고르는** 자리용. 리스 두
 * 종류가 목록에 나란히 놓이므로 '구독' 단독은 어느 쪽인지 모호하다 → 운용/금융을
 * 둘 다 적는다.
 *
 * 쓰는 곳(정정3 26-07-28 로 두 곳이 됐다):
 *   • 계약 등록 마법사 '배치 사유' 드롭다운 (ContractCreateWizard)
 *   • 로봇 배치 모달 '사유' 드롭다운 (robots/DeployRobotModal) — 종전엔 자체
 *     라벨 세트를 들고 있었다. 이 자리도 리스 두 값이 나란히 놓이므로 긴 표기가
 *     맞다(맥락 라벨을 새로 만들 필요가 없었다).
 *
 * 짧은 표기를 펼친 뒤 **LEASE_OPERATING 한 값만** 덮어쓴다 — 값→문구 매핑을
 * 두 벌로 늘리지 않기 위한 것이다(다시 갈라지면 시험이 깨진다:
 * contract-reason.test.ts '두 표기 세트는 머리 단어가 같다').
 */
export const CONTRACT_REASON_OPTION_LABEL: Record<DeploymentReason, string> = {
  ...CONTRACT_REASON_LABEL,
  LEASE_OPERATING: '구독(운용리스)',
};

/**
 * 계약 사실화 1단계 정정3(26-07-28) — **폐기 어휘**. 위 두 세트로 수렴하면서
 * 화면에서 걷어낸 단어들이다(계약 등록 마법사 · 로봇 배치 모달 · 고객사 마스터
 * 모달의 줄별 칸이 쓰던 것).
 *
 * 여기 한 곳에 적어 두는 이유: 어느 화면이 이 단어를 다시 들고 오는지 지키는
 * 시험이 세 파일(contract-reason.test.ts / DeployRobotModal.test.tsx /
 * CustomerMasterCreateModal.test.tsx)에 있는데, 각 시험이 자기 목록을 따로 들면
 * 또 갈라진다. 세 시험이 이 배열을 함께 부른다.
 *
 * ⚠ 여기 담는 것은 **DeploymentReason 을 사람에게 보여 주는 단어**만이다. 서버로
 * 보내는 문자열(고객사 마스터 공통 '계약 형태'의 '렌탈' / '판매')은 폐기 대상이
 * 아니므로 절대 넣지 않는다 — 위 ⚠ 참조.
 */
export const RETIRED_CONTRACT_REASON_WORDS: readonly string[] = [
  '운용 리스',
  '금융 리스',
  '데모',
  '이벤트',
  '내부',
  // 계약 사실화 1단계 정정4(26-07-29) — 고객사 마스터 모달 줄별 칸이 쓰던 단독
  // '금융리스'(붙여쓴 형태). 정본은 머리 단어를 살린 '구독(금융리스)' 다.
  '금융리스',
];

/**
 * DeploymentReason → 한국어 표기. 값이 없으면 en-dash, 모르는 값(서버가 먼저
 * 새 enum 값을 내려주는 경우)은 원문을 그대로 보여 준다 — 조용히 다른 뜻으로
 * 뭉개지 않는다(enum-labels.ts 의 robotStatusLabel 과 같은 폴백 관례).
 */
export function formatContractReason(reason: string | null | undefined): string {
  if (!reason) return CONTRACT_REASON_EMPTY;
  return CONTRACT_REASON_LABEL[reason as DeploymentReason] ?? reason;
}

/**
 * 계약 사실화 1단계 정정6(26-07-29) — 서버 요약의 구분자(가운뎃점 양옆 공백).
 * 서버(customer-master.row.deriveContractTypeSummary)와 아래 파서가 **같은 글자**를
 * 써야 하므로 화면 쪽에는 여기 한 번만 적는다.
 */
export const CONTRACT_TYPE_SUMMARY_SEPARATOR = ' · ';

/**
 * 계약 사실화 1단계 정정6(26-07-29) — 서버가 내리는 **계약 형태 요약**을 정본 표기로
 * 옮긴다. 감사 로그의 '계약 형태' 칸이 이 함수를 부른다.
 *
 * 왜 필요한가 — 정정5 가 서버 요약(deriveContractTypeSummary)을 **원문 7값 기준**으로
 * 바꾼 것은 옳았다(그 전엔 파일럿 계약이 감사에 '렌탈'로 남았다 — 거짓 기록이었다).
 * 그런데 그 값이 감사 스냅샷에 그대로 실리고 감사 로그 화면은 문자열을 번역하지 않아,
 * 운영자가 매일 보는 칸이 'LEASE_OPERATING → SALE' / 'PILOT 1 · LEASE_OPERATING 2'
 * 로 퇴행했다. 서버가 한국어를 만들면 정본이 두 벌이 되므로(위 파일 주석) 서버는
 * 그대로 두고 **화면이 번역한다.** 그 규칙이 있어야 하는 자리는 표기 정본인 이 파일이다.
 *
 * 받는 형태는 서버가 만드는 두 가지뿐이다:
 *   • 'PILOT'                       — 전 줄이 같음(원문 값 하나)
 *   • 'PILOT 1 · LEASE_OPERATING 2' — 갈림. `${원문값} ${대수}` 를 ' · ' 로 이음
 *
 * ⚠ 형식을 파싱하는 것이 취약하지 않은가(서버가 값 배열을 내리는 편이 낫지 않은가) —
 * 원칙적으로는 배열이 낫지만 이 자리에서는 파싱이 맞다:
 *   ① 감사 로그는 **과거 기록**이다. 이미 저장된 AuditLog.diff 행에 이 문자열이 들어
 *      있으므로 서버를 지금 바꿔도 그 행들은 영영 영문으로 남는다 — 화면은 어차피
 *      문자열을 읽을 수 있어야 한다.
 *   ② 판정이 **전부 아니면 전무**다. 토큰 하나라도 모르는 값이면 null 을 돌려 호출부가
 *      원문을 그대로 보여 준다 → 서버가 형식을 바꿨을 때 최악이 '오늘과 같은 상태'
 *      (영문 노출)이고, 틀린 한국어로 뭉개지는 일은 없다.
 * 서버 쪽 형식은 deriveContractTypeSummary 한 곳에서만 만들어진다(그 함수 주석이 이
 * 파서를 가리킨다).
 *
 * @returns 번역된 문구, 또는 **서버 요약이 아니면 null**(호출부가 원문 폴백을 쓴다).
 *   옛 기록(정정5 전의 접힌 한국어 표기 '판매 1 · 렌탈 2')도 null 이 되어 그대로 보인다
 *   — 이미 한국어이므로 손댈 이유가 없다.
 */
export function formatContractTypeSummary(raw: string): string | null {
  const parts = raw.split(CONTRACT_TYPE_SUMMARY_SEPARATOR);
  const out: string[] = [];
  for (const part of parts) {
    // `VALUE` 또는 `VALUE 3`. 원문 enum 은 대문자+밑줄이라 공백도 가운뎃점도 품지 않는다.
    const m = /^([A-Z][A-Z_]*)(?: (\d+))?$/.exec(part.trim());
    if (!m) return null;
    const label = CONTRACT_REASON_LABEL[m[1] as DeploymentReason];
    // 모르는 값이 섞이면 **통째로 포기**한다 — 절반만 번역해 보여 주지 않는다.
    if (!label) return null;
    out.push(m[2] === undefined ? label : `${label} ${m[2]}`);
  }
  return out.length > 0 ? out.join(CONTRACT_TYPE_SUMMARY_SEPARATOR) : null;
}

// ============================================================================
// 오너 지시(26-07-29) — 운영 화면의 '구분'은 **구독/판매 두 값으로만** 보여 준다
// ============================================================================

/**
 * 운영 화면에서 쓰는 두 단어. 오너가 실제로 쓰는 말이고, 이 두 개면 충분하다.
 */
export const CONTRACT_KIND_SALE = '판매';
export const CONTRACT_KIND_SUBSCRIPTION = '구독';

/**
 * 7값을 **구독/판매 두 값으로 접는다.** 오너 지시(26-07-29): "구분은 구독과
 * 판매로만 표시되면 됩니다."
 *
 * ⚠⚠ **표시 전용이다. 상속·판정·저장의 근거로 절대 쓰지 말 것.** ⚠⚠
 * 이 접기는 **되돌릴 수 없다** — 파일럿·시연·행사·사내·금융리스가 모두 '구독'
 * 한 단어가 되므로, 접힌 값을 다시 값으로 되돌리면 그 5종이 전부
 * LEASE_OPERATING 으로 덮인다. 이 차수가 그 사고를 세 갈래로 겪었다(정정5 참조:
 * 줄 칸을 '공통값 따름'으로 되돌리면 파일럿이 구독으로 덮이던 것 / 파일럿 전용
 * 계약에 줄을 추가하면 구독으로 저장되던 것 / SALE 없는 혼합이 '렌탈' 한 단어로
 * 접혀 혼합으로 인지되지 않던 것).
 *
 * **저장은 7값 그대로 유지된다.** 화면이 접어 보여 주더라도 파일럿 줄은 파일럿으로
 * 남는다 — 서버의 '접힌 메아리 보호'(customer-master.service.ts isFoldedEcho)가
 * "들어온 두 값 표기가 기존 값을 접은 결과와 같으면 기존 값을 지킨다"로 막는다.
 * 그래서 접어 보여 주는 것이 데이터를 망가뜨리지 않는다.
 *
 * 부수 효과(의도된 것) — '확인 필요'가 정확해진다. 같은 모델에 파일럿 줄과 구독
 * 줄이 섞인 경우 종전에는 판정 불가였지만, 접으면 **둘 다 구독**이라 갈리지 않는다.
 * 그래서 '확인 필요'는 **판매와 구독이 실제로 갈릴 때만** 남는다(백암한옥구이처럼
 * 진짜 확인이 필요한 건).
 */
export function foldContractReasonToKind(reason: string | null | undefined): string | null {
  if (!reason) return null;
  if (!(reason in CONTRACT_REASON_LABEL)) return null;
  return reason === 'SALE' ? CONTRACT_KIND_SALE : CONTRACT_KIND_SUBSCRIPTION;
}

/**
 * 여러 줄의 값을 접어 운영 표기 하나로 만든다.
 *
 * @returns
 *   - 줄이 없거나 전부 모르는 값 → null (호출부가 '–' 를 쓴다)
 *   - 접은 결과가 한 종류 → '판매' | '구독'
 *   - 접은 결과가 갈림 → { ambiguous: true } 로 알리지 않고 **수량 요약**을 낸다
 *     ('판매 1 · 구독 2'). 갈렸다는 사실 자체가 정보이므로 감추지 않는다.
 */
export function foldContractReasonsToKindSummary(
  reasons: ReadonlyArray<string | null | undefined>,
): string | null {
  const counts = new Map<string, number>();
  for (const r of reasons) {
    const kind = foldContractReasonToKind(r);
    if (kind) counts.set(kind, (counts.get(kind) ?? 0) + 1);
  }
  if (counts.size === 0) return null;
  if (counts.size === 1) return [...counts.keys()][0];
  // 판매를 앞에 둔다 — 스윕이 찾는 것이 '판매인데 구독으로 적힌 것'이라 판매가 먼저 눈에 와야 한다.
  return [CONTRACT_KIND_SALE, CONTRACT_KIND_SUBSCRIPTION]
    .filter((k) => counts.has(k))
    .map((k) => `${k} ${counts.get(k)}`)
    .join(CONTRACT_TYPE_SUMMARY_SEPARATOR);
}
